<script setup lang="ts">
/**
 * Diese Klasse ist eine Wrapper Klasse für den IonButton, um den Klick/Touch-Effekt vom IonButton zu ändern.
 * Beim Klick/Touch wird der Hintergrund und die Schriftfarbe getauscht und der Button wird von Filled zu Outlined
 */
import type { JSX } from '@ionic/core'

const props = defineProps<JSX.IonButton & { icon?: string }>()
</script>

<template>
	<ion-button
		v-bind="props"
		fill="solid"
	>
		<i
			v-if="icon"
			:slot="$slots.default ? 'start' : 'icon-only'"
			:class="['mdi', icon, { 'with-text': $slots.default }]"
			aria-hidden="true"
		/>
		<slot />
	</ion-button>
</template>

<style scoped lang="scss">
ion-button {
	height: 48px;
	text-transform: none;
	--background: var(--ion-color-secondary);
	--background-hover: var(--ion-color-secondary);
	--background-activated: var(--ion-color-primary);
	--background-focused: var(--ion-color-primary);

	--background-activated-opacity: 1;
	--background-focused-opacity: 1;

	--color: var(--ion-color-primary);
	--color-hover: var(--ion-color-primary);
	--color-activated: var(--ion-color-secondary);
	--color-focused: var(--ion-color-secondary);

	--border-radius: 32px;
	--border-color: var(--ion-color-secondary);
	--border-style: solid;
	--border-width: 2px;

	--box-shadow: none;

	font-weight: 700;

	.mdi {
		font-size: 20px;
		&.with-text {
			margin-right: 8px;
		}
	}

	&.button-disabled {
		opacity: 1;
		--background: var(--ion-color-grey-4);
		--border-color:var(--ion-color-grey-4);
		--color: var(--ion-color-grey-3);
	}
}
</style>
